import React from "react";
import ProfilePresenter from "./ProfilePresenter";

// eslint-disable-next-line import/no-anonymous-default-export
export default class extends React.Component {
  render() {
    return <ProfilePresenter />;
  }
}
